(function(){
  var root = document.querySelector('[data-koi-showcase]');
  if (!root) return;
  var panes = root.querySelectorAll('.ks-pane');
  var thumbs = root.querySelectorAll('[data-ks-thumb]');
  var tabs = root.querySelectorAll('[data-ks-tab]');

  function show(id){
    var target = null;
    panes.forEach(function(p){ if (p.dataset.mediaId == id) target = p; });
    if (!target) return;
    panes.forEach(function(p){
      var on = p === target;
      p.classList.toggle('is-on', on);
      var v = p.querySelector('video');
      if (v && !on) v.pause();
    });
    thumbs.forEach(function(t){ t.classList.toggle('is-on', t.dataset.ksThumb == id); });
    var kind = target.dataset.ksPane;
    tabs.forEach(function(t){ t.setAttribute('aria-selected', t.dataset.ksTab === kind ? 'true' : 'false'); });
    var vid = target.querySelector('video');
    if (vid) { vid.play().catch(function(){}); }
  }
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ show(t.dataset.ksThumb); }); });
  tabs.forEach(function(t){ t.addEventListener('click', function(){
    var first = root.querySelector('.ks-pane[data-ks-pane="' + t.dataset.ksTab + '"]');
    if (first) show(first.dataset.mediaId);
  }); });

  /* full-screen photo */
  var dlg = root.parentNode.querySelector('[data-ks-lightbox]');
  var zoom = root.querySelector('[data-ks-zoom]');
  if (zoom && dlg && dlg.showModal) {
    zoom.addEventListener('click', function(){
      var pane = root.querySelector('.ks-pane.is-on');
      /* video showing: open the real video full screen, not its poster image */
      if (pane && pane.dataset.ksPane === 'video') {
        var el = pane.querySelector('video') || pane.querySelector('iframe');
        if (!el) return;
        if (el.tagName === 'VIDEO') { el.play().catch(function(){}); }
        if (el.requestFullscreen) { el.requestFullscreen().catch(function(){}); }
        else if (el.webkitEnterFullscreen) { el.webkitEnterFullscreen(); }
        else if (el.webkitRequestFullscreen) { el.webkitRequestFullscreen(); }
        return;
      }
      var cur = (pane && pane.querySelector('img')) || root.querySelector('.ks-pane[data-ks-pane="photo"] img');
      if (!cur) return;
      dlg.querySelector('img').src = cur.getAttribute('data-full') || cur.currentSrc || cur.src;
      dlg.showModal();
    });
    dlg.querySelector('[data-ks-close]').addEventListener('click', function(){ dlg.close(); });
    dlg.addEventListener('click', function(e){ if (e.target === dlg) dlg.close(); });
  }

  /* size ruler animation */
  var fish = root.querySelector('[data-ks-fish]');
  if (fish && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(es, o){ es.forEach(function(e){ if (e.isIntersecting){ fish.style.width = fish.dataset.ksFish + '%'; o.disconnect(); } }); }, {threshold:.4}).observe(fish);
  } else if (fish) { fish.style.width = fish.dataset.ksFish + '%'; }

  /* arrival countdown */
  var cd = root.querySelector('[data-ks-countdown]');
  if (cd) {
    var d = new Date(cd.dataset.ksCountdown + 'T12:00:00');
    var days = Math.round((d - new Date()) / 86400000);
    if (isNaN(days)) { cd.remove(); }
    else if (days > 13) { cd.textContent = 'About ' + Math.round(days / 7) + ' weeks until it lands'; }
    else if (days > 0) { cd.textContent = days + (days === 1 ? ' day' : ' days') + ' until it lands'; }
    else { cd.textContent = 'Landing any day now'; }
  }

  /* variants */
  var idInput = root.querySelector('[data-ks-id]');
  var priceEl = root.querySelector('[data-ks-price] strong');
  root.querySelectorAll('input[name="ks-variant"]').forEach(function(r){
    r.addEventListener('change', function(){
      idInput.value = r.value;
      if (priceEl) priceEl.textContent = r.dataset.price;
      if (r.dataset.media) show(r.dataset.media);
      var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u);
    });
  });


  /* open / closed status (shop hours, Pacific time) */
  var hrs = root.querySelector('[data-ks-hours]');
  if (hrs) {
    hrs.classList.add('is-js');
    try {
      var openDays = (hrs.dataset.days || '2,3,4,5,6').split(',').map(Number); /* 0=Sun */
      var open = Number(hrs.dataset.open || 10), close = Number(hrs.dataset.close || 17);
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date());
      var wd = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(parts.find(function(p){return p.type==='weekday';}).value);
      var hr = Number(parts.find(function(p){return p.type==='hour';}).value) % 24;
      var names = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      var fmt = function(h){ return (h % 12 || 12) + (h < 12 ? 'am' : 'pm'); };
      var isOpen = openDays.indexOf(wd) > -1 && hr >= open && hr < close;
      var dot = hrs.querySelector('.dot'), txt = hrs.querySelector('.txt');
      if (isOpen) { dot.classList.add('is-open'); txt.textContent = 'We’re open now. Questions go straight to our koi team.'; }
      else {
        var n = wd, label = '';
        for (var i = 0; i < 8; i++) {
          if (openDays.indexOf(n) > -1 && (i > 0 || hr < open)) { label = i === 0 ? 'today' : (i === 1 ? 'tomorrow' : names[n]); break; }
          n = (n + 1) % 7;
        }
        txt.textContent = 'We’re closed right now. Send your question and we’ll get back to you when we open ' + label + ' at ' + fmt(open) + '.';
      }
    } catch (e) {}
  }


  /* sold koi: "Request a similar koi" pre-fills the question form */
  root.querySelectorAll('[data-ks-similar]').forEach(function(b){
    b.addEventListener('click', function(){
      var q = root.querySelector('[data-ks-q]');
      var st = root.querySelector('[data-ks-status]');
      if (q && !q.value) q.value = b.dataset.msg || '';
      if (st) st.value = 'SOLD - customer wants a similar koi';
      setTimeout(function(){ if (q) q.focus({ preventScroll: true }); }, 500);
    });
  });

  /* Japan acknowledgement gate */
  var form = root.querySelector('[data-ks-form]');
  if (!form) return;
  var atc = form.querySelector('[data-ks-atc]');
  var ack = form.querySelector('[data-ks-ack]');
  var hint = form.querySelector('[data-ks-hint]');
  var err = form.querySelector('[data-ks-err]');
  var inJapan = root.dataset.inJapan === 'true';
  if (ack) ack.addEventListener('change', function(){
    atc.disabled = !ack.checked;
    if (hint) hint.style.visibility = ack.checked ? 'hidden' : 'visible';
  });

  /* ===== Ship date picker (in-stock koi) =====
     Koi ship Tue (arrive Wed) and Thu (arrive Fri) by UPS overnight,
     after a fast. Edit these to change the rules: */
  var SHIP_FAST_DAYS = 5;
  var SHIP_BLACKOUT = ['2026-11-26', '2026-12-24', '2026-12-31']; /* YYYY-MM-DD: holidays, weather, trips */
  var SHIP_DATES_SHOWN = 6;
  var SHIP_NOTE = 'Your koi arrives by UPS overnight on a Wednesday or Friday. Every koi is fasted for ' + SHIP_FAST_DAYS + ' days before it ships, so the earliest dates are shown below.';
  var SHIP_MIXED = 'Ordering food or supplies too? Those ship separately by UPS Ground, usually the same or next business day.';

  var sd = null, sdNote = null;
  if (!inJapan) {
    var shipRadio = null;
    form.querySelectorAll('input[name="ks-plan"]').forEach(function(r){ if (!shipRadio && /^Ship to me/.test(r.value)) shipRadio = r; });
    if (shipRadio) {
      shipRadio.value = 'Ship to me';
      shipRadio.setAttribute('data-ks-ship', '');
      var small = shipRadio.parentNode.querySelector('small');
      if (small) small.textContent = 'UPS overnight. Pick your arrival date below.';
    }
    if (!document.getElementById('ks-shipdate-css')) {
      var css = document.createElement('style');
      css.id = 'ks-shipdate-css';
      css.textContent = '.ks-shipdate{margin:14px 0 16px;padding:16px;border:1px solid var(--ks-line,#ddd);border-radius:12px;background:#fff}'
        + '.ks-shipdate[hidden]{display:none}'
        + '.ks-shipdate-h{font-family:"Shippori Mincho",serif;font-size:18px;font-weight:600;margin:0 0 4px}'
        + '.ks-shipdate-note{font-size:13px;color:var(--ks-ink-2,#555);margin:0 0 12px;line-height:1.5}'
        + '.ks-shipdate-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:8px}'
        + '.ks-sd{position:relative;display:block;border:1px solid var(--ks-line,#ddd);border-radius:10px;padding:10px 12px;cursor:pointer;background:var(--ks-paper,#fbf8f2)}'
        + '.ks-sd input{position:absolute;opacity:0;pointer-events:none}'
        + '.ks-sd b{display:block;font-size:15px}'
        + '.ks-sd small{display:block;font-size:12px;color:var(--ks-ink-2,#555);margin-top:2px}'
        + '.ks-sd:has(input:checked){border-color:var(--ks-ink,#111);box-shadow:inset 0 0 0 1px var(--ks-ink,#111);background:#fff}'
        + '.ks-sd:has(input:focus-visible){outline:2px solid var(--ks-indigo,#2b3a67);outline-offset:2px}'
        + '.ks-sd .first{display:block;margin-bottom:2px;font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:var(--ks-red,#b3261e);font-weight:600}'
        + '.ks-shipdate-req{margin-top:12px;font-size:13.5px}'
        + '.ks-shipdate-req summary{cursor:pointer;color:var(--ks-indigo,#2b3a67);font-weight:600}'
        + '.ks-shipdate-req textarea{width:100%;margin-top:8px;border:1px solid var(--ks-line,#ddd);border-radius:8px;padding:10px 12px;font:14px Inter,sans-serif;background:var(--ks-paper,#fbf8f2)}'
        + '.ks-shipdate-mixed{font-size:12.5px;color:var(--ks-ink-2,#555);margin:12px 0 0;line-height:1.5}';
      document.head.appendChild(css);
    }
    sd = document.createElement('div');
    sd.className = 'ks-shipdate';
    sd.innerHTML = '<p class="ks-shipdate-h">Choose your arrival date</p><p class="ks-shipdate-note"></p>'
      + '<div class="ks-shipdate-grid" role="radiogroup" aria-label="Arrival date"></div>'
      + '<details class="ks-shipdate-req"><summary>Need a different date?</summary>'
      + '<textarea rows="2" maxlength="300" placeholder="Tell us what works for you, and we\'ll do our best."></textarea></details>'
      + '<p class="ks-shipdate-mixed"></p>';
    sd.querySelector('.ks-shipdate-note').textContent = SHIP_NOTE;
    sd.querySelector('.ks-shipdate-mixed').textContent = SHIP_MIXED;
    sdNote = sd.querySelector('textarea');
    var sdGrid = sd.querySelector('.ks-shipdate-grid');
    var fs = form.querySelector('fieldset.ks-plan');
    if (fs) fs.parentNode.insertBefore(sd, fs.nextSibling); else form.insertBefore(sd, atc);

    var p0 = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric' })
      .formatToParts(new Date()).forEach(function(p){ p0[p.type] = p.value; });
    var DAY = 86400000;
    var today = Date.UTC(+p0.year, +p0.month - 1, +p0.day);
    var dfmt = function(t, o){ return new Date(t).toLocaleDateString('en-US', Object.assign({ timeZone: 'UTC' }, o)); };
    var iso = function(t){ return new Date(t).toISOString().slice(0, 10); };
    var t = today + SHIP_FAST_DAYS * DAY, shown = 0, limit = today + 60 * DAY;
    while (shown < SHIP_DATES_SHOWN && t <= limit) {
      var dow = new Date(t).getUTCDay();
      if ((dow === 2 || dow === 4) && SHIP_BLACKOUT.indexOf(iso(t)) === -1) {
        var arrive = dfmt(t + DAY, { weekday: 'short', month: 'short', day: 'numeric' });
        var shipDay = dfmt(t, { weekday: 'short', month: 'short', day: 'numeric' });
        var lab = document.createElement('label');
        lab.className = 'ks-sd';
        lab.innerHTML = '<input type="radio" name="ks-shipdate"' + (shown === 0 ? ' checked' : '') + '>' + (shown === 0 ? '<span class="first">Earliest</span>' : '') + '<b></b><small></small>';
        lab.querySelector('input').value = dfmt(t + DAY, { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }) + ' (ships ' + shipDay + ')';
        lab.querySelector('b').textContent = 'Arrives ' + arrive;
        lab.querySelector('small').textContent = '(Ships ' + shipDay + ')';
        sdGrid.appendChild(lab);
        shown++;
      }
      t += DAY;
    }
    var syncShip = function(){
      var radios = form.querySelectorAll('input[name="ks-plan"]');
      var p = form.querySelector('input[name="ks-plan"]:checked');
      sd.hidden = radios.length > 0 && !(p && p.hasAttribute('data-ks-ship'));
    };
    form.querySelectorAll('input[name="ks-plan"]').forEach(function(r){ r.addEventListener('change', syncShip); });
    syncShip();
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    if (inJapan && ack && !ack.checked) return;
    err.style.display = 'none';
    var items = [];
    var props = {};
    if (inJapan) {
      var plan = form.querySelector('input[name="ks-plan"]:checked');
      props['Status'] = root.dataset.inQt === 'true' ? 'In quarantine at Mystic Koi' : 'Still in Japan — est. arrival ' + root.dataset.arrival;
      props['Quarantine complete'] = root.dataset.qt;
      props['Delivery plan'] = plan ? plan.value : '';
      props['Timeline acknowledged'] = 'Yes — ' + new Date().toLocaleDateString('en-US');
      if (root.dataset.koiId) props['Koi ID'] = root.dataset.koiId;
      items.push({ id: Number(idInput.value), quantity: 1, properties: props });
      if (plan && plan.hasAttribute('data-ks-hold')) {
        items.push({ id: Number(root.dataset.holdId), quantity: 1, properties: { 'For koi': root.dataset.title } });
      }
    } else {
      var plan2 = form.querySelector('input[name="ks-plan"]:checked');
      var props2 = {};
      if (plan2) props2['Delivery plan'] = plan2.value;
      if (sd && !sd.hidden) {
        var pick = form.querySelector('input[name="ks-shipdate"]:checked');
        var req = sdNote && sdNote.value.trim();
        if (!pick && !req) {
          err.textContent = 'Please choose an arrival date, or tell us what date works for you.';
          err.style.display = 'block';
          return;
        }
        if (pick) props2['Arrival date'] = pick.value;
        if (req) props2['Date request'] = req;
      }
      if (root.dataset.koiId) props2['Koi ID'] = root.dataset.koiId;
      items.push({ id: Number(idInput.value), quantity: 1, properties: props2 });
      if (plan2 && plan2.hasAttribute('data-ks-hold') && root.dataset.holdId) {
        items.push({ id: Number(root.dataset.holdId), quantity: 1, properties: { 'For koi': root.dataset.title } });
      }
    }
    atc.disabled = true;
    var label = atc.textContent; atc.textContent = 'Adding…';
    /* ask the theme which sections (cart drawer, cart count) to re-render */
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = !!drawer && window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'drawer';
    var body = { items: items };
    if (useDrawer && sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
    fetch(root.dataset.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(added){
        if (!useDrawer) { window.location.href = root.dataset.cartUrl; return; }
        return fetch(root.dataset.cartUrl + '.js').then(function(r){ return r.json(); }).then(function(cart){
          cart.sections = added.sections || {};
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart } }));
          atc.disabled = false; atc.textContent = 'Added to cart ✓';
          setTimeout(function(){ atc.textContent = label; }, 2500);
          /* if the drawer could not refresh from the bundled sections, fall back to the cart page */
          if (!added.sections || !Object.keys(added.sections).length) { window.location.href = root.dataset.cartUrl; }
        });
      })
      .catch(function(j){
        atc.disabled = false; atc.textContent = label;
        err.textContent = (j && (j.description || j.message)) || 'Something went wrong. Please call the shop.';
        err.style.display = 'block';
      });
  });
})();
